import { AssetBase } from './base/asset-base';

export class Asset extends AssetBase { }